import React, { useState, useEffect } from "react";
import { makeRequest2 } from "../../../../../utils/makeRequest";
import { toastify } from "../../../../../utils/toast";

const MasterWorkplanModal = ({
  show,
  onClose,
  onSuccess,
  facilityId,
  workplan,
}) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    life: "Active",
    status: "Approved",
  });

  useEffect(() => {
    if (workplan) {
      setFormData({
        title: workplan.title || "",
        description: workplan.description || "",
        life: workplan.life || "Active",
        status: workplan.status || "Approved",
      });
    } else {
      setFormData({
        title: "",
        description: "",
        life: "Active",
        status: "Approved",
      });
    }
  }, [workplan]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const submitData = {
        title: formData.title,
        description: formData.description,
        life: formData.life,
        status: formData.status,
      };

      let response;
      if (workplan) {
        response = await makeRequest2(
          `/api/work_plan/master/${facilityId}/${workplan._id}`,
          "PUT",
          submitData,
        );
      } else {
        response = await makeRequest2(
          `/api/work_plan/master/${facilityId}`,
          "POST",
          submitData,
        );
      }

      if (response.success) {
        onSuccess();
      } else {
        toastify(response.error || "An error occurred", "error");
      }
    } catch (error) {
      toastify("An error occurred", "error");
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div
      className="modal d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {workplan ? "Edit Master Workplan" : "Add Master Workplan"}
            </h5>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Title *</label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={formData.title}
                      onChange={handleInputChange}
                      placeholder="e.g., Generator Maintenance"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Description *</label>
                    <textarea
                      className="form-control"
                      name="description"
                      rows="4"
                      value={formData.description}
                      onChange={handleInputChange}
                      placeholder="Describe the master workplan..."
                      required
                    />
                  </div>
                </div>

                <div className="col-md-6">
                  <div className="mb-3">
                    <label className="form-label">Life Status</label>
                    <select
                      className="form-select"
                      name="life"
                      value={formData.life}
                      onChange={handleInputChange}
                    >
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Approval Status</label>
                    <select
                      className="form-select"
                      name="status"
                      value={formData.status}
                      onChange={handleInputChange}
                    >
                      <option value="Pending">Pending</option>
                      <option value="Approved">Approved</option>
                      <option value="Rejected">Rejected</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <div className="alert alert-info">
                      <small>
                        <strong>Note:</strong> After creating this master
                        workplan, you can add child workplans that define
                        specific tasks and procedures.
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading && (
                  <span className="spinner-border spinner-border-sm me-2"></span>
                )}
                {workplan ? "Update" : "Create"} Master Workplan
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default MasterWorkplanModal;
